<template>
  <div>
    <b-row v-if="tableData.length > 0">
      <b-col cols="6">
        <soft-table
          :pending="false"
          class="table align-items-center table-flush"
          tbody-classes="list"
          :dataTable="tableData"
          @rowClicked="handleClickRow"
        >
          <template slot="columns">
            <th>Mã</th>
            <th>Người tạo</th>
            <th>Người xác thực</th>
            <th>Trạng thái</th>
            <th>Ngày tạo</th>
          </template>
          <template slot-scope="{ row }">
            <td>{{ row.code }}</td>
            <td>{{ row.userCreate ? row.userCreate.name : "--" }}</td>
            <td>{{ row.userVerify ? row.userVerify.name : "--" }}</td>
            <td>{{ row.status ? "Đã xác thực" : "Chưa xác thực" }}</td>
            <td>{{ $dateTime(row.dateCreated) }}</td>
          </template>
        </soft-table>
      </b-col>
      <b-col cols="6">
        <soft-table
          :pending="false"
          class="table align-items-center table-flush"
          tbody-classes="list"
          :dataTable="rowSelected.quotaDetails"
        >
          <template slot="columns">
            <th>Mã sản phẩm</th>
            <th>Tên sản phẩm</th>
            <th>Màu</th>
            <th>Quy cách</th>
            <th>Số lượng</th>
            <th>Giá</th>
          </template>
          <template slot-scope="{ row }">
            <td>{{ row.product.code }}</td>
            <td>{{ row.product.name }}</td>
            <td>{{ row.color }}</td>
            <td>{{ row.productSpecify.name }}</td>
            <td>{{ row.quantity }}</td>
            <td>{{ row.price }}</td>
          </template>
        </soft-table>
      </b-col>
    </b-row>
    <b-row v-else class="text-center p-4">
      <h5 class="d-block text-center" style="padding: 13px;">
        Bạn chưa từng báo giá cho khách hàng này
      </h5>
      <div style="width:200px">
        <add-button @click="$emit('doCreateQuote')">báo giá mới</add-button>
      </div>
    </b-row>
  </div>
</template>

<script>
import SoftTable from "@/components/SoftComponents/SoftTable";
import { customerService } from "@/_services";
export default {
  props: {
    customerId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    SoftTable
  },
  data: () => ({
    tableData: [],
    rowSelected: {}
  }),
  watch: {
    async customerId() {
      await this.$nextTick();
      this.fetchTableData();
    }
  },
  methods: {
    handleClickRow(row) {
      this.rowSelected = { ...row };
    },
    async fetchTableData() {
      const res = await customerService.findQuota(this.customerId);
      this.tableData = res.data;
    }
  }
};
</script>

<style></style>
